import { isLocalHost, isProduction } from "../agent";

const AUTH_PRD = "https://auth.the.select";
const AUTH_STG = "https://auth.s12e.co";
const AUTH_LOCAL = "http://localhost:4000";

const getAuthUrl = () => {
  if (isLocalHost()) {
    return AUTH_LOCAL;
  }
  if (!isProduction) {
    return AUTH_STG;
  }
  return AUTH_PRD;
};

export const getSignUpURL = () => {
  const query: any = {
    path: typeof window !== "undefined" ? window.location.href : "",
    type: "csb",
    useCodeVerification: true,
  };
  const searchParams = new URLSearchParams(query);
  const queryString = searchParams.toString();
  return `${getAuthUrl()}/?${queryString}`;
};
